export const SENTRY_TYPE = {
  ERROR: 'error',
} as const

export const SENTRY_CATEGORY = {
  PROVIDER_RESULTS: 'ProviderResults',
} as const

export const SENTRY_MESSAGE = {
  FAILED_TO_SAVE_PROVIDER_LEVEL_FEEDBACK: 'Failed to save provider level feedback',
} as const

export const SENTRY_LEVEL = {
  ERROR: 'error',
} as const
